import { colorsPalette } from '../colors';

export default `
  a:focus,
  button:focus,
  .tab-element:focus,
  select:focus {
    outline: 1px solid ${colorsPalette.teal};
  }
`;
